import { useEffect } from 'react';

export default function Terms() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="min-h-screen bg-black pt-32 pb-20 px-4 sm:px-6">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">Termos de Utilização</h1>
                <div className="text-gray-300 space-y-6 leading-relaxed">

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">1. Aceitação dos Termos</h2>
                        <p>Ao aceder e utilizar os serviços da TV4KLIVE, aceita estar vinculado pelos presentes termos de utilização. Se não aceitar estes termos, por favor não utilize os nossos serviços.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">2. Descrição do Serviço</h2>
                        <p>A TV4KLIVE fornece um serviço de acesso a fluxos de streaming IPTV. Não somos proprietários dos conteúdos transmitidos e não alojamos nenhum ficheiro nos nossos servidores. Atuamos como intermediário técnico.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">3. Utilização da Conta</h2>
                        <p>A sua subscrição é pessoal e não deve ser partilhada publicamente. A partilha de conta para além dos limites do seu plano (número de ecrãs) pode resultar na suspensão do seu acesso sem reembolso.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">4. Pagamentos e Renovações</h2>
                        <p>Os pagamentos são efetuados uma única vez pela duração escolhida. Não há renovação automática, exceto indicação explícita em contrário. Os preços estão sujeitos a alterações a qualquer momento.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">5. Responsabilidade</h2>
                        <p>A TV4KLIVE esforça-se por fornecer um serviço estável 24/7. No entanto, não podemos garantir uma disponibilidade ininterrupta devido à natureza técnica da internet. Não somos responsáveis por interrupções devidas ao seu fornecedor de acesso à internet.</p>
                    </section>
                </div>
            </div>
        </main>
    );
}
